import drvijaya from "./assets/vijaya.png";
import dermatology from "./assets/dermatology.webp";
import chemical from "./assets/Chemical-Peel.jpg";
import acne from "./assets/acne.webp";
import pigmentation from "./assets/pigmentation.png";
import infection from "./assets/infection.png";
import vitiligo from "./assets/vitiligo.png";
import hair from "./assets/hair.webp";
import first from "./assets/13.JPG";
import second from "./assets/2.JPG";
import third from "./assets/4.JPG";
import fourth from "./assets/15.JPG";
import five from "./assets/5.JPG";
import six from "./assets/11.JPG";
import eith from "./assets/IFT.webp";
import infections from "./assets/Fungal-infections.webp";


export const clinicInfo = {
  name: "V Derma Skin Clinic",
  tagline: "Your only go to place for a healthier skin",
  phone: "8618947826",
  address: "68, Bauxite Road, Sangameshwar Nagar, APMC Road, Belagavi, Karnataka 590019",
  email: "vdermaskinclinic@gmail.com",
  workingHours: {
    weekdays: "Monday – Friday: 12:00 AM – 7:00 PM",
    saturday: "Saturday: 12:00 AM – 5:00 PM",
    sunday: "Sunday: Closed"
  }
};

export const stats = [
  { value: "5000+", label: "Happy Patients" },
  { value: "20+", label: "Years of Experience" },
  { value: "15+", label: "Treatment Options" },
  { value: "98%", label: "Success Rate" }
];

export const services = [
  {
  id: 1,
  title: "Dermatology Treatment",
  description: "Comprehensive skin care treatments for acne, pigmentation, rashes, infections, and other skin conditions with expert dermatological care.",
  image: dermatology,
  category: "Dermatology"
  },
  {
    id: 2,
    title: "Chemical Peels",
    description: "Specialized treatments for various skin concerns including texture, tone, and pigmentation.",
    image: chemical,
    category: "Advanced Procedures"
  },
  {
    id: 3,
    title: "Acne Scar Treatment",
    description: "Focused treatment for significant improvement of skin texture and acne scarring.",
    image: acne,
    category: "General Dermatology"
  },
  {
    id: 4,
    title: "Pigmentation Treatment",
    description: "Targeting dark spots and uneven skin tone for a brighter, more radiant complexion.",
    image: pigmentation,
    category: "General Dermatology"
  },
  {
    id: 5,
    title: "Fungal Infection Treatment",
    description: "Specialized care for regional fungal concerns with proven treatment protocols.",
    image: infection,
    category: "General Dermatology"
  },
  {
    id: 6,
    title: "Psoriasis & Vitiligo Management",
    description: "Long-term dermatological care and management for chronic skin conditions.",
    image: vitiligo,
    category: "General Dermatology"
  },
  {
    id: 7,
    title: "Hair & Scalp Treatments",
    description: "Comprehensive treatment for dandruff, scalp psoriasis, and hair thinning.",
    image: hair,
    category: "General Dermatology"
  },
];

// mockData.js
export const galleryImages = [
  {
    id: 1,
    image: first,
    title: "Facade"
  },
  {
    id: 2,
    image: second,
    title: "Reception Room"
  },
  {
    id: 3,
    image: third,
    title: "Waiting Room"
  },
  {
    id: 4,
    image: fourth,
    title: "Waiting Room"
  },
  {
    id: 5,
    image: five,
    title: "Examination Couch"
  },
  {
    id: 6,
    image: six,
    title: "Doctor Cabin"
  },
  {
    id: 7,
    image: eith,
    title: "machine"
  },
];


export const blogPosts = [
  {
    id: 1,
    title: "Fungal Skin Infections: Causes, Symptoms, Treatment & Prevention",
    excerpt: "Fungal skin infections are one of the most common skin problems, especially in warm and humid climates like India. They can affect people of all ages and, if left untreated, may spread and become chronic. Understanding the causes, symptoms, and proper treatment is essential for healthy skin.",
    content: `
What Is a Fungal Skin Infection?
A fungal skin infection occurs when fungi grow excessively on the skin. These fungi thrive in warm, moist areas of the body such as skin folds, groin, underarms, feet, and scalp. Fungal infections are contagious and can spread through direct contact or shared personal items.

Common Types of Fungal Skin Infections:
• Ringworm (Tinea) – Circular, red, itchy patches
• Athlete’s Foot – Itching and cracking between toes
• Jock Itch – Red rashes in the groin area
• Candidiasis – Infection in skin folds or genital areas
• Fungal Nail Infection – Thickened, discolored nails

Symptoms of Fungal Skin Infection:
✔ Itching or burning sensation
✔ Red, scaly, or cracked skin
✔ Circular rashes with raised borders
✔ Peeling or flaking of skin

If symptoms persist, consult a dermatologist.
    `,
    image: infections,
    author: "Dr. Vijaya Sajjan Hosalli",
    date: "2026-01-08",
    category: "Prevention"
  },
  {
    id: 2,
    title: "The Difference Between Scalp Psoriasis and Dandruff",
    excerpt: "Understanding the key differences and treatment approaches for these common scalp conditions.",
    content: `
Dandruff is caused by excess oil and fungus.
Psoriasis is an autoimmune condition.

Key differences:
• Psoriasis causes thick silvery scales
• Dandruff causes flaky white skin

Treatments differ significantly, so diagnosis is important.
    `,
    image: "https://images.pexels.com/photos/4672476/pexels-photo-4672476.jpeg",
    author: "Dr. Vijaya Sajjan Hosalli",
    date: "2024-12-10",
    category: "Education"
  },
  {
    id: 3,
    title: "The Difference Between Scalp Psoriasis and Dandruff",
    excerpt: "Understanding the key differences and treatment approaches for these common scalp conditions.",
    content: `
Dandruff is caused by excess oil and fungus.
Psoriasis is an autoimmune condition.

Key differences:
• Psoriasis causes thick silvery scales
• Dandruff causes flaky white skin

Treatments differ significantly, so diagnosis is important.
    `,
    image: "https://images.pexels.com/photos/4672476/pexels-photo-4672476.jpeg",
    author: "Dr. Vijaya Sajjan Hosalli",
    date: "2024-12-10",
    category: "Education"
  },
];


export const faqs = [
  {
    id: 1,
    question: "What is a fungal skin infection and how is it treated?",
    answer: "Fungal skin infections are caused by fungi that grow on moist areas of the body. Common symptoms include itching, redness, and circular rashes. Treatment usually involves antifungal creams, lotions, or oral medications depending on the severity."
  },
  {
    id: 2,
    question: "Why do I get dandruff and how can it be controlled?",
    answer: "Dandruff occurs due to excess oil, fungal growth, or dry scalp. It can be controlled with medicated anti-dandruff shampoos, proper scalp hygiene, and dermatologist-recommended treatments."
  },
  {
    id: 3,
    question: "What causes acne and is it permanently curable?",
    answer: "Acne is caused by clogged pores, excess oil, bacteria, and hormonal changes. While acne can be effectively controlled and scars minimized, consistent treatment and skincare are essential for long-term results."
  },
  {
    id: 4,
    question: "How can pigmentation be reduced or removed?",
    answer: "Pigmentation occurs due to sun exposure, hormonal imbalance, or skin injury. Treatments include medicated creams, chemical peels, laser therapy, and sun protection to prevent further darkening."
  },
  {
    id: 5,
    question: "What's the difference between various chemical peels?",
    answer: "Chemical peels vary in strength and ingredients. Superficial peels treat mild concerns with no downtime, medium peels address moderate issues with 3-7 days recovery, and deep peels treat severe concerns with longer recovery. We'll recommend the best option for your skin type and goals."
  },
  {
    id: 6,
    question: "What is Vitiligo and can normal skin color return?",
    answer: "Vitiligo causes loss of skin color due to pigment cell damage. Treatment options such as topical medicines, phototherapy, and advanced dermatological procedures can help restore pigmentation in many cases."
  },
  {
    id: 7,
    question: "What are skin tags and how are they removed?",
    answer: "Skin tags are harmless growths commonly seen on the neck, armpits, or groin. They can be safely removed using radiofrequency, electrocautery, or minor procedures without scars."
  },
  {
    id: 8,
    question: "What is Lichen Planus and is it dangerous?",
    answer: "Lichen Planus is a chronic inflammatory skin condition causing itchy, purplish rashes. It is not contagious and can be managed with medications that reduce inflammation and itching."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "varsha shindhe",
    rating: 5,
    text: "I had an exceptional experience at V Derma Skin Clinic ! The treatment I received was not only highly effective but also truly curative. I'm extremely grateful for the outstanding care and expertise provided.Dr. Vijaya Sajjan is a compassionate and skilled professional who genuinely prioritizes her patients' well-being.I highly recommend V Derma Skin Clinic to anyone seeking top-notch medical care!",
    treatment: ""
  },
  {
    id: 2,
    name: "Roshan Patil",
    rating: 5,
    text: "Best dermatologist in Belgaum",
    treatment: ""
  },
  {
    id: 3,
    name: "Basavaraj Pujeri",
    rating: 5,
    text: "Good treatment at affordable medicine and all,it helps me lot Thank you Dr.",
    treatment: ""
  },
  {
    id: 4,
    name: "Shantha Kola",
    rating: 5,
    text: "Very good doctor. She is very patient and is very understanding about patients needs",
    treatment: ""
  }
];

export const doctorInfo = {
  name: "Dr. Vijaya Sajjan Hosalli",
  qualification: "MBBS, DDVL, DNB (Dermatology)",
  experience: "20+ Years",
  specialization: "Dermatology, Cosmetology & Trichology",
  image: drvijaya,
  about: "Dr. Vijaya Sajjan, MBBS, DDVL, DNB, is a highly experienced dermatologist with a passion for treating a variety of skin conditions. She is fluent in Kannada, English, and Hindi, making her accessible to a wide range of patients. Dr. Sajjan has a special interest in treating acne, eczema, psoriasis, skin cancer, melasma, and vitiligo. She is skilled in performing procedures such as chemical peels, microdermabrasion, laser hair removal, dermabrasion, skin biopsy, and electrocautery. Dr. Sajjan is committed to providing personalized care to each of her patients and is dedicated to staying up-to-date on the latest advancements in dermatology. With a strong background in research and numerous publications, she is well-respected in her field. Her expertise spans from general dermatology to advanced cosmetic procedures, making her one of the most trusted dermatologists in Belgaum.",
  achievements: [
    "Successfully treated over 5000+ patients",
    "Specialized training in advanced dermatological procedures",
    "Published research in dermatological journals",
    "Member of Indian Association of Dermatologists"
  ]
};
